<template>
	<div class="con">
		<div class="title">{{parameter.ksmc}}科室</div>
		<div class="text">{{parameter.REMARK}}</div>
		<div class="depart-footer" @click="registeredBtn">去挂号</div>
	</div>
</template>

<script>
	export default {
		name: 'departmentInfo',
		data() {
			return {
				msg: '科室介绍',
				parameter: {},//传递的参数
			}
		},
		methods: {
			
			registeredBtn(){
				console.log('挂号')
				this.$router.push({
					path: 'registeredDeta',
					query: this.parameter
				})
			}
		},
		mounted() {
			console.log(this.$route.query)
			this.parameter = this.$route.query;
		}
	}
</script>

<style scoped>
	.con{
		display: flex;
		flex-direction: column;
		height: 100%;
	}
	.title{
		padding: 20px 0;
		text-align: center;
		font-size: 18px;
		color: #333;
		width: 100%;
	}
	.text{
		flex: 1;
		padding: 10px;
		text-indent: 2em;
		font-size: 14px;
		color: #666;
	}
	.depart-footer{
		padding: 16px 0;
		text-align: center;
		font-size: 16px;
		width: 100%;
		color: #fff;
		background-color: #27BEC4;
	}
</style>
